import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiEdit3, FiChevronRight } from 'react-icons/fi';

const AdhikDakhleDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const certificates = [
    "बिअर शॉपी ना हरकत दाखला",
    "चांगल्या वर्तणुकीचा दाखला",
    "जात प्रमाणपत्रासाठी जातीचा दाखला",
    "हयातीचा दाखला",
    "जन्म / मृत्यू / नोंद अनुपलब्धता प्रमाणपत्र",
    "शासकीय नोकरीत नसल्याबाबतचा दाखला",
    "पुर्नविवाह केला नसल्याबाबतचा दाखला",
    "निराधार योजनेसाठी वयाचा दाखला",
    "शौचालय दाखला",
    "पाणी वापरासाठी ग्रामपंचायतीचा दाखला",
    "विधवा असल्याचा दाखला",
    "बेघर दाखला",
    "परितक्त्या प्रमाणपत्र",
    "घटस्फोटित असल्याचा अथवा घटस्फोट सुरु",
    "पिण्याचे पाणी उपलब्धतेचा दाखला",
    "कुटुंब प्रमाणपत्र"
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-[#267c77] text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">अधिक दाखले</h1>
            <p className="text-white/80">
              {grampanchayatName || "ग्रामपंचायत"} | आर्थिक वर्ष: {arthikVarshLabel || "२०२४-२५"}
            </p>
          </div>
          <button 
            onClick={() => navigate('/asthapan-dashboard')}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
          >
            मागे जा
          </button>
        </div>
      </div>

      {/* Certificates Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {certificates.map((cert, index) => (
          <div 
            key={index}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 border-l-4 border-[#267c77] cursor-pointer group flex items-center justify-between"
            onClick={() => console.log(`Clicked on ${cert}`)}
          >
             <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#267c77]/10 flex items-center justify-center text-[#267c77] group-hover:bg-[#267c77] group-hover:text-white transition-colors duration-300">
                    <FiEdit3 className="w-5 h-5" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-[#267c77] transition-colors">
                  {cert}
                </h3>
             </div>
             <FiChevronRight className="text-gray-400 group-hover:text-[#267c77] transform group-hover:translate-x-1 transition-all" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdhikDakhleDashboard;
